import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal, FormLayout,  } from '@shopify/polaris';
import { BasicTextField } from '@presentational';

import { tAttribute } from '@utils';


const propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAction: PropTypes.func,
  fieldProps: PropTypes.object,
  variants: PropTypes.array,
  variantIndex: PropTypes.number.isRequired,
  apb: PropTypes.bool.isRequired,

  variantsURL: PropTypes.string,
  isAdmin: PropTypes.bool.isRequired,
};

const defaultProps = {
  // variants: []
}


const VariantModal = (props) => {
  const variant = props.variants[props.variantIndex];
  const showDetails = variant && (!!props.variantsURL && variant.shopify_id)
  return(
    <Modal
      title=""
      open={props.open}
      onClose={props.onClose}
      primaryAction={{
        content: I18n.t("actions.save"),
        onAction: props.onClose,
      }}
      secondaryActions={ showDetails ? {
        content: I18n.t("actions.view_details"),
        external: true,
        url: `${props.variantsURL}/${variant.id}/edit`
      } : null
    }
    >
      <Modal.Section>
        { variant &&
          <FormLayout>
            <FormLayout.Group>
              <BasicTextField
                {...props.fieldProps}
                name={`variants[${props.variantIndex}]price`}
                label={tAttribute("variant", "price")}
                value={variant.price }
                type="number"props
                min="0"
                readOnly={ !props.isAdmin }
              />
              <BasicTextField
                {...props.fieldProps}
                name={`variants[${props.variantIndex}]unit_cost`}
                label={tAttribute("variant", "unit_cost")}
                value={variant.unit_cost}
                type="number"
                min="0"
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <BasicTextField
                {...props.fieldProps}
                name={`variants[${props.variantIndex}]sku`}
                label={tAttribute("variant", "sku")}
                value={variant.sku}
              />
              <BasicTextField
                {...props.fieldProps}
                name={`variants[${props.variantIndex}]barcode`}
                label={tAttribute("variant", "barcode")}
                value={variant.barcode}
              />
            </FormLayout.Group>

            {/* Can't specify inventory if apb is active */}
            { !props.apb  &&
              <BasicTextField
                {...props.fieldProps}
                type="number"
                min="0"
                name={`variants[${props.variantIndex}]inventory_quantity`}
                label={tAttribute("variant", "inventory_quantity")}
                value={ (variant.inventory_quantity && variant.inventory_quantity.toString()) }
              />
            }
          </FormLayout>
        }
      </Modal.Section>
    </Modal>
  );
}

VariantModal.propTypes = propTypes;
VariantModal.defaultProps = defaultProps;


export default VariantModal;
